import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $types } from './Utilities.types'

@Injectable({ providedIn: 'root' })
export class Utilities_list_processesService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { application_name?: string, process_name?: string, action?: string }): Promise<{ list?: { id?: string, application_name?: string, process_name?: string }[] }> 
  {
    let url = `${environment.backendUrl}api/Utilities/functions/list_processes`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

